import React from "react"
import Heading from "app/components/Heading"
import Box from "app/components/Box"
import { useTranslate } from "hooks/translate"
import { parseTags } from "i18n/utils/parseTags"

const ErrorPhoneVerification: React.FC = () => {
  const { t } = useTranslate()

  return (
    <Box>
      <Heading>{t("page.error-phone-verification.heading", parseTags)}</Heading>
      <p>{t("error.phone-verification")}</p>
    </Box>
  )
}

export default ErrorPhoneVerification
